var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkToLightColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1440px",
    height: "294px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "divider",
    x: 0,
    y: 0,
    width: 1440,
    height: 294,
    style: {
      fill: "#383128"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1440,
    height: 294
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer-3",
    serifId: "layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house-and-car-3",
    serifId: "house and car 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1211.82,191.335C1201.57,194.945 1197.37,175.141 1209.4,170.002C1217.12,166.708 1218.03,171.624 1222.86,170.204C1229.06,168.383 1222.72,158.072 1234.81,154.216C1248.58,149.825 1258.37,166.593 1254.81,174.699C1252.88,179.092 1252.29,184.558 1248.41,186.065C1243.74,187.876 1239.01,189.507 1234.38,191.412C1226.8,194.532 1224.25,186.959 1211.82,191.335Z",
    style: {
      fill: "#628e4f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1348.58,74.085C1348.3,73.054 1347.37,72.339 1346.3,72.339C1345.23,72.339 1344.29,73.054 1344.01,74.085C1339.49,90.432 1329.8,127.543 1329.8,145.899C1329.8,160.77 1337.19,172.842 1346.3,172.842C1355.4,172.842 1362.8,160.77 1362.8,145.899C1362.8,127.543 1353.11,90.432 1348.58,74.085Z",
    style: {
      fill: "#638e50"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "trees-2",
    serifId: "trees 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1388.73,163.283C1396.71,166.47 1400.4,151.349 1391.05,146.912C1385.06,144.068 1384.24,147.826 1380.48,146.541C1375.65,144.894 1380.83,137.183 1371.41,133.734C1360.69,129.806 1352.66,142.365 1355.31,148.762C1356.74,152.228 1357.09,156.47 1360.11,157.785C1363.74,159.366 1367.42,160.809 1371.02,162.461C1376.91,165.165 1379.06,159.42 1388.73,163.283Z",
    style: {
      fill: "#638e50"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1162.3,183.916C1162.3,183.457 1162.12,183.016 1161.8,182.691C1161.47,182.366 1161.03,182.184 1160.57,182.184C1157.44,182.184 1150.8,182.184 1146.91,182.184C1146.29,182.184 1145.71,181.848 1145.4,181.306C1145.1,180.763 1145.11,180.097 1145.43,179.562C1148.59,174.301 1152.04,169.585 1156.04,165.906C1156.59,165.437 1156.78,164.68 1156.53,164.007C1156.28,163.335 1155.64,162.889 1154.92,162.889C1153.16,162.875 1151.27,162.875 1149.82,162.875C1149.26,162.875 1148.73,162.603 1148.41,162.145C1148.08,161.688 1148,161.101 1148.18,160.571C1150.07,155.295 1152.71,150.466 1156.93,146.566C1157.45,146.096 1157.63,145.35 1157.38,144.691C1157.13,144.032 1156.5,143.597 1155.79,143.597C1155.56,143.566 1155.32,143.566 1155.09,143.566C1154.47,143.566 1153.9,143.234 1153.59,142.695C1153.28,142.156 1153.29,141.493 1153.6,140.957C1157.09,135.04 1160.99,130.006 1165.52,126.324C1166.16,125.816 1167.06,125.824 1167.69,126.343C1172.75,130.545 1176.27,135.553 1178.62,141.186C1178.84,141.717 1178.77,142.322 1178.45,142.797C1178.13,143.273 1177.6,143.559 1177.02,143.559C1176.59,143.566 1176.13,143.566 1175.66,143.566C1174.95,143.566 1174.31,144.004 1174.05,144.669C1173.79,145.334 1173.96,146.09 1174.49,146.573C1178.8,150.579 1181.69,155.315 1183.51,160.595C1183.69,161.121 1183.6,161.699 1183.28,162.15C1182.95,162.6 1182.43,162.867 1181.88,162.867C1180.51,162.875 1178.72,162.875 1177.04,162.875C1176.31,162.875 1175.65,163.333 1175.41,164.021C1175.16,164.708 1175.37,165.476 1175.93,165.942C1180.77,169.966 1184.16,174.636 1186.63,179.712C1186.88,180.246 1186.85,180.874 1186.53,181.374C1186.21,181.874 1185.66,182.177 1185.07,182.177C1181.41,182.184 1174.95,182.184 1171.87,182.184C1170.91,182.184 1170.13,182.959 1170.13,183.916C1170.13,188.657 1170.13,201.493 1170.13,201.493L1162.3,201.493L1162.3,183.916Z",
    style: {
      fill: "#638e50"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1245.63,79.416L1257.2,60.201L1289.69,79.554L1288.16,182.15L1244.4,182.15L1245.63,79.416Z",
    style: {
      fill: "#ffebba"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1245.63,79.416L1257.2,60.201L1289.69,79.554L1288.16,182.15L1244.4,182.15L1245.63,79.416Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1249.3,85.675C1249.31,85.382 1249.38,85.094 1249.53,84.84C1250.41,83.289 1253.75,77.466 1255.56,74.303C1255.8,73.878 1256.25,73.616 1256.74,73.616C1257.23,73.617 1257.68,73.88 1257.92,74.306C1259.73,77.472 1263.05,83.302 1263.92,84.845C1264.07,85.096 1264.14,85.38 1264.14,85.669C1264.21,92.113 1264.91,167.289 1265.03,179.642C1265.03,180.094 1264.86,180.53 1264.54,180.852C1264.22,181.174 1263.78,181.355 1263.33,181.355C1260.22,181.355 1253.68,181.355 1250.58,181.355C1250.12,181.355 1249.69,181.175 1249.37,180.855C1249.05,180.535 1248.88,180.101 1248.88,179.65C1248.93,167.326 1249.27,92.165 1249.3,85.675Z",
    style: {
      fill: "#fff8f5",
      fillOpacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.35,157.278C1252.35,156.128 1252.8,155.025 1253.62,154.212C1254.43,153.399 1255.53,152.942 1256.68,152.942C1256.68,152.942 1256.68,152.942 1256.68,152.942C1257.83,152.942 1258.93,153.399 1259.75,154.212C1260.56,155.025 1261.02,156.128 1261.02,157.278C1261.02,165.234 1261.02,181.355 1261.02,181.355L1252.35,181.355L1252.35,157.278Z",
    style: {
      fill: "#70cca7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1255.79,60.275C1255.23,60.277 1254.71,60.567 1254.42,61.044C1252.46,64.198 1245.03,76.215 1242.52,80.26C1242.35,80.537 1242.34,80.885 1242.49,81.172C1242.64,81.459 1242.94,81.643 1243.27,81.655C1243.92,81.679 1244.64,81.705 1245.12,81.722C1245.44,81.733 1245.74,81.575 1245.92,81.306C1247.65,78.625 1256.85,64.457 1256.85,64.457C1256.85,64.457 1265.54,77.704 1267.64,80.907C1267.92,81.339 1268.4,81.599 1268.92,81.599C1272.33,81.599 1285.42,81.599 1291.18,81.599C1291.73,81.599 1292.24,81.298 1292.52,80.813C1292.79,80.327 1292.77,79.734 1292.48,79.262C1289.52,74.484 1282.91,63.807 1281.13,60.927C1280.85,60.475 1280.35,60.2 1279.82,60.202C1277.76,60.208 1272.69,60.224 1272.69,60.224C1272.69,60.224 1272.69,55.165 1272.69,53.104C1272.69,52.877 1272.6,52.659 1272.44,52.498C1272.28,52.337 1272.06,52.247 1271.84,52.247C1270.98,52.247 1269.68,52.247 1268.83,52.247C1268.36,52.247 1267.97,52.631 1267.97,53.104C1267.97,55.168 1267.97,60.239 1267.97,60.239C1267.97,60.239 1258.75,60.267 1255.79,60.275Z",
    style: {
      fill: "#037f6e"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1210.35,155.463C1210.35,154.376 1211.24,153.495 1212.32,153.495C1212.32,153.495 1212.33,153.495 1212.33,153.495C1213.41,153.495 1214.29,154.376 1214.29,155.463C1214.29,163.106 1214.29,190.396 1214.29,190.396L1210.35,190.396L1210.35,155.463Z",
    style: {
      fill: "#383128"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1210.35,155.463C1210.35,154.376 1211.24,153.495 1212.32,153.495C1212.32,153.495 1212.33,153.495 1212.33,153.495C1213.41,153.495 1214.29,154.376 1214.29,155.463C1214.29,163.106 1214.29,190.396 1214.29,190.396L1210.35,190.396L1210.35,155.463Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1210.35,
    y: 149.555,
    width: 3.94,
    height: 9.85,
    style: {
      fill: "#20f58f"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1281.65,136.657L1295.41,110.491L1335.24,136.782L1334.9,178.691L1281.69,178.691L1281.65,136.657Z",
    style: {
      fill: "#ffebba"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1281.65,136.657L1295.41,110.491L1335.24,136.782L1334.9,178.691L1281.69,178.691L1281.65,136.657Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1285.3,139.145C1285.3,138.918 1285.35,138.693 1285.44,138.485C1286.39,136.35 1291.87,123.927 1294.43,118.131C1294.65,117.628 1295.15,117.307 1295.7,117.318C1296.25,117.328 1296.74,117.667 1296.94,118.178C1299.26,124 1304.18,136.383 1305.02,138.492C1305.1,138.696 1305.14,138.913 1305.14,139.133C1305.11,142.993 1304.81,179.365 1304.75,187.671C1304.74,188.603 1303.98,189.355 1303.05,189.355C1299.26,189.355 1290.11,189.355 1286.28,189.355C1285.83,189.355 1285.39,189.172 1285.07,188.849C1284.76,188.525 1284.58,188.087 1284.59,187.633C1284.71,179.262 1285.24,143.066 1285.3,139.145Z",
    style: {
      fill: "#fff8f5",
      fillOpacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1295.33,127.614C1295.25,127.422 1295.07,127.295 1294.86,127.295C1294.66,127.295 1294.47,127.422 1294.4,127.614C1293.49,129.945 1291.5,135.066 1290.59,137.418C1290.48,137.694 1290.52,138.006 1290.68,138.251C1290.85,138.496 1291.13,138.643 1291.42,138.643C1293.24,138.643 1296.49,138.643 1298.3,138.643C1298.6,138.643 1298.87,138.496 1299.04,138.251C1299.21,138.006 1299.25,137.694 1299.14,137.418C1298.22,135.066 1296.23,129.945 1295.33,127.614Z",
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.59,105.919C1293.25,105.92 1292.94,106.109 1292.78,106.411C1291.01,109.821 1280.5,130.028 1277.68,135.446C1277.53,135.729 1277.54,136.069 1277.71,136.342C1277.87,136.615 1278.17,136.782 1278.49,136.782L1281.18,136.782C1281.52,136.782 1281.84,136.592 1281.99,136.29C1283.87,132.684 1295.41,110.491 1295.41,110.491C1295.41,110.491 1306.34,131.501 1308.66,135.958C1308.93,136.464 1309.45,136.782 1310.02,136.782C1314.21,136.782 1331.46,136.782 1337.99,136.782C1338.53,136.782 1339.02,136.503 1339.3,136.046C1339.58,135.588 1339.6,135.019 1339.35,134.545C1336.08,128.263 1326.92,110.661 1324.83,106.634C1324.57,106.126 1324.04,105.808 1323.47,105.81C1318.72,105.827 1297.31,105.905 1293.59,105.919Z",
    style: {
      fill: "#037f6e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1272.45,34.794C1271.9,35.777 1270.86,36.387 1269.73,36.387C1268.61,36.387 1267.57,35.778 1267.02,34.794C1263.76,29.468 1258.74,20.489 1258.74,15.766C1258.74,9.921 1263.67,5.176 1269.73,5.176C1275.8,5.176 1280.72,9.921 1280.72,15.766C1280.72,20.489 1275.71,29.468 1272.45,34.794Z",
    style: {
      fill: "#037f6e"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1272.45,34.794C1271.9,35.777 1270.86,36.387 1269.73,36.387C1268.61,36.387 1267.57,35.778 1267.02,34.794C1263.76,29.468 1258.74,20.489 1258.74,15.766C1258.74,9.921 1263.67,5.176 1269.73,5.176C1275.8,5.176 1280.72,9.921 1280.72,15.766C1280.72,20.489 1275.71,29.468 1272.45,34.794Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1274.54,13.136C1275.71,14.304 1275.71,16.198 1274.54,17.367C1273.37,18.535 1271.48,18.535 1270.31,17.367L1268.23,15.283C1268.01,15.07 1267.67,15.07 1267.46,15.283C1267.25,15.495 1267.25,15.84 1267.46,16.053L1268.96,17.551C1267.78,18.532 1266.03,18.47 1264.92,17.367C1263.76,16.198 1263.76,14.304 1264.92,13.136C1266.09,11.967 1267.99,11.967 1269.16,13.136L1271.24,15.219C1271.45,15.431 1271.8,15.431 1272.01,15.219C1272.22,15.006 1272.22,14.662 1272.01,14.45L1270.51,12.952C1271.69,11.971 1273.44,12.032 1274.54,13.136ZM1269.73,12.185C1271.34,10.775 1273.78,10.836 1275.31,12.366C1276.9,13.96 1276.9,16.543 1275.31,18.136C1273.78,19.667 1271.34,19.727 1269.73,18.316C1268.13,19.727 1265.69,19.667 1264.16,18.136C1262.56,16.543 1262.56,13.96 1264.16,12.366C1265.69,10.836 1268.13,10.775 1269.73,12.185Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer-4",
    serifId: "layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mountains-3",
    serifId: "mountains 3",
    d: "M0,234.745L0,294L1440,294L1440,148.355C1206.06,164.192 1176.05,213.394 1044.6,223.932C918.132,234.07 843.51,203.525 672.093,215.937C550.278,224.757 468.66,254.94 358.057,260.877C219.988,268.289 93.551,257.786 0,234.745Z",
    style: {
      fill: "url(#_Linear6)"
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mountains-31",
    serifId: "mountains 3",
    d: "M0,234.745L0,294L1440,294L1440,148.355C1206.06,164.192 1176.05,213.394 1044.6,223.932C918.132,234.07 843.51,203.525 672.093,215.937C550.278,224.757 468.66,254.94 358.057,260.877C219.988,268.289 93.551,257.786 0,234.745Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1296.95,165.643C1280.37,172.298 1247.6,178.298 1267.73,187.369C1275.09,190.688 1272.75,196.127 1252.35,204.546C1219.09,218.269 1196.48,219.551 1195.76,225.732C1195.1,231.286 1229.33,236.176 1224.59,249.263C1217.83,267.893 1131.95,283.301 1095.74,292.076C1101.62,287.559 1099.09,281.088 1099.09,281.088C1123.8,272.437 1214.6,254.569 1208.03,246.492C1202.95,240.235 1172.05,228.901 1184.55,221.816C1200.48,212.784 1277.35,200.157 1254.58,185.933C1241.62,177.837 1278.38,167.711 1294.15,166.088L1296.95,165.643Z",
    style: {
      fill: "#fffad4",
      fillOpacity: 0.35
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.065,215.884C102.065,215.884 100.798,174.217 100.906,153.334C100.939,146.84 101.444,138.896 108.704,135.742C109.777,135.276 110.94,134.995 112.116,134.982C115.905,134.94 119.517,136.56 123.354,136.303C126.11,136.118 133.843,136.172 131.913,131.349C129.898,126.314 122.943,129.427 119.173,128.589C113.628,127.356 110.446,120.925 104.313,120.826C101.152,120.775 99.794,123.095 97.509,124.703C95.603,126.045 93.239,126.382 90.951,126.093C84.288,125.252 79.056,118.448 71.765,122.067C68.158,123.858 65.979,127.753 62.484,129.82C61.354,130.488 60.073,130.741 58.777,130.854C57.517,130.963 56.256,130.972 54.993,131.025C52.047,131.15 42.076,134.711 47.527,138.525C49.873,140.167 53.471,140.005 56.188,140.205C59.172,140.425 62.307,139.775 65.252,139.392C67.795,139.061 70.255,138.91 72.786,139.442C81.645,141.302 87.706,151.666 93.889,157.035C96.988,159.726 96.584,174.76 96.576,183.786C96.567,194.364 96.482,204.946 96.022,215.516C96.022,215.516 102.065,215.884 102.065,215.884ZM75.79,137.367C75.42,137.521 77.959,139.777 79.328,140.385C83.473,142.226 85.011,143.946 88.444,148.039C89.889,149.762 95.862,156.019 96.175,156.001C96.385,155.988 95.914,152.021 95.897,150.203C95.853,145.673 96.945,138.338 96.032,137.331C94.631,135.786 88.319,139.468 83.901,138.681C79.943,137.976 80.235,135.517 75.79,137.367Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.988,82.626C156.939,81.65 156.157,80.871 155.181,80.827C154.205,80.784 153.355,81.489 153.22,82.457C149.198,109.723 142.218,160.19 142.218,182.107C142.218,201.218 145.924,215.884 151.576,215.884C157.228,215.884 160.934,202.067 160.934,182.956C160.934,161.039 158.43,110.139 156.988,82.626Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.902,104.653C171.841,103.592 170.991,102.748 169.93,102.692C168.869,102.637 167.936,103.389 167.766,104.438C163.711,127.843 157.033,169.127 157.033,187.28C157.033,203.464 160.739,215.884 166.391,215.884C172.043,215.884 175.748,204.184 175.748,188C175.748,169.861 173.357,128.279 171.902,104.653Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.823,215.267C226.21,219.783 231.41,198.216 218.069,191.924C209.516,187.891 208.366,193.251 202.995,191.433C196.109,189.101 203.468,178.092 190.033,173.209C174.73,167.647 163.336,185.577 167.123,194.686C169.175,199.622 169.688,205.666 173.998,207.531C179.176,209.771 184.437,211.816 189.569,214.158C197.971,217.991 201.022,209.795 214.823,215.267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "mountains-1",
    serifId: "mountains 1",
    d: "M1440,269.784C1246.85,313.613 1146.6,250.646 924.109,265.97C721.393,279.933 598.947,310.704 413.305,248.932C199.205,177.691 98.682,210.02 -0,217.992L-0,294L1440,294L1440,269.784Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.00001,431.553,-7.16938,0.0166132,602,106.007)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1b6a33",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#bebc74",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffdd8e",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkToLightColor);
export default __webpack_public_path__ + "static/media/dark-to-light-color.ea4d259aa50026126bee496e3ac5afab.svg";
export { ForwardRef as ReactComponent };